import React from 'react';
import { Row, Col, Table, Button, ListGroup, Form } from 'react-bootstrap';
import { map, filter, isEmpty } from 'lodash';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import uuid from 'uuid/v1';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';
import PaginationComponent from '../Pagination';
import delay from '../../../modules/delay';

const ServerInfra = ({ gmsConnections, loading }) => {
  const [databody, setDatabody] = React.useState([]);
  const [loadParameters, setLoadParameters] = React.useState([]);
  const [schemas, setSchemas] = React.useState([]);
  const [Sch, setSch] = React.useState([]);
  const [body, setBody] = React.useState([]);
  const [ids, setIds] = React.useState([]);
  const [isUsers, setIsUsers] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [bodyfiltered, setBodyFiltered] = React.useState([]);
  const [name, setName] = React.useState('');
  const [filte, setFilte] = React.useState([]);
  const [indexArray, setIndexArray] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [currentSchema, setCurrenShema] = React.useState('');

  const Header = [
    {
      name: 'Load Schema',
      sortValue: 'Schema'
    },
    {
      name: 'GMS Name',
      sortValue: 'name'
    },
    {
      name: ' GMS Ip',
      sortValue: 'Ip'
    },
    {
      name: 'GMS Port',
      sortValue: 'port'
    },
    {
      name: ' PG Ip',
      sortValue: 'IpPG'
    },
    {
      name: 'PG Port',
      sortValue: 'portPG'
    },
    {
      name: 'Data Base Name',
      sortValue: 'data'
    },
    {
      name: 'GeoServer',
      sortValue: 'urlGeoServer'
    }
  ];
  const listSchemas = async (index, value) => {
    setIsLoading(true);
    setName(value);
    setCurrentPage(1);
    setCurrenShema('');
    setBodyFiltered([]);

    try {
      const { schema, tableBody } = await methodPromise(
        'sources.ListSchemas',
        loadParameters[index]
      );
      setBody(tableBody);
      setSchemas(schema);
      setIndexArray(schema);
      setIsLoading(false);
    } catch (error) {
      handleErrorInClient(error);
    }
  };
  const previewSource = async () => {
    const GMS = filter(gmsConnections, value => {
      if (value.serverType === 'GMS') {
        return true;
      }
      return false;
    });
    const directions = map(GMS, value => {
      if (!isEmpty(value.domain)) {
        return `https://${value.domain}`;
      }
      return `http://${value.ip}:${value.port}`;
    });

    try {
      const Result = await methodPromise('sources.InfoInfrastructure', directions);

      const Body = map(Result, (value, idx) => {
        return [
          GMS[idx].name,
          isEmpty(GMS[idx].ip) ? `https://${GMS[idx].domain}` : GMS[idx].ip,
          GMS[idx].port,
          value.ip,
          value.port,
          value.database_name,
          value.geoserver
        ];
      });
      setDatabody(Body);
      setLoadParameters(Result);
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const fetchUsers = async search => {
    const usersPerPage = 15;

    try {
      const { users } = await methodPromise('admin.fetchUsers', {
        currentPage,
        perPage: usersPerPage,
        search
      });
      const id = [...new Set(map(users, item => [item._id, item.emails[0].address]))];
      const sch = [...new Set(map(users, item => item._id))];
      setSch(sch);
      setIds(id);
      return Sch;
    } catch (error) {
      handleErrorInClient(error);
      return [];
    }
  };
  const loadTable = id => {
    const tables = filter(body, item => item[0] === id);
    setCurrenShema(id);
    setBodyFiltered(tables);
  };
  const handleSearch = event => {
    event.persist();
    delay(() => fetchUsers(event.target.value.trim()), 500);
    const searchRegex = new RegExp(event.target.value.trim(), 'i');
    const filteredLayers = filter(schemas, layer => searchRegex.test(layer));
    filteredLayers.push(...Sch);
    const ids2 = [...new Set(map(filteredLayers, item => item))];
    setIndexArray(ids2);
  };
  const fiterbyUser = () => {
    if (isUsers) {
      setIndexArray(schemas);
    } else {
      const filteredLayers = filter(schemas, layer => Sch.includes(layer));
      setIndexArray(filteredLayers);
    }

    setIsUsers(!isUsers);
  };
  React.useEffect(() => {
    if (!loading) {
      previewSource();
      fetchUsers();
    }
  }, [loading]);

  return (
    <Row>
      <Col xs={8}>
        <Table striped bordered hover>
          <thead>
            <tr>
              {map(Header, value => {
                return <th key={value.sortValue}> {value.name} </th>;
              })}
            </tr>
          </thead>
          <tbody>
            {map(databody, (value, index) => {
              return (
                <tr key={uuid()}>
                  <td key={uuid()}>
                    <Button
                      variant="light"
                      title="Open"
                      onClick={() => {
                        listSchemas(index, value[0]);
                      }}
                    >
                      <FontAwesomeIcon icon="file-alt" size="lg" />
                    </Button>
                  </td>
                  {map(value, (event, key, val) => {
                    if (key === val.length - 1) {
                      return (
                        <td key={uuid()}>
                          <a href={event} target="_blank" rel="noreferrer noopener">
                            <FontAwesomeIcon icon={['fa', 'link']} size="sm" /> Link
                          </a>
                        </td>
                      );
                    }
                    return <td key={uuid()}> {event}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Col>
      {isLoading ? (
        false
      ) : (
        <>
          <Col xs={12}>
            <h5>{`Schemas en el servidor ${name}`}</h5>
          </Col>

          <Col xs={6}>
            <ListGroup variant="flush">
              {map(filte, item => {
                if (!ids.flat().includes(item)) {
                  if (!isUsers) {
                    return (
                      <ListGroup.Item
                        key={uuid()}
                        action
                        onClick={() => {
                          loadTable(item);
                        }}
                      >
                        <ListGroup horizontal="md" className="py-0" key={item[0]}>
                          <ListGroup.Item
                            key={uuid()}
                            className="py-0 border-0"
                            style={{ backgroundColor: 'transparent', width: '50%' }}
                          >
                            Schema: {item}
                          </ListGroup.Item>

                          <ListGroup.Item
                            key={uuid()}
                            className="py-0 border-0"
                            style={{ backgroundColor: 'transparent', width: '50%' }}
                          >
                            PostgreSQL
                          </ListGroup.Item>
                        </ListGroup>
                      </ListGroup.Item>
                    );
                  }
                  return false;
                }
                const index = ids.flat().indexOf(item);
                const email = ids.flat()[index + 1];
                return (
                  <ListGroup.Item
                    key={uuid()}
                    action
                    onClick={() => {
                      loadTable(item);
                    }}
                  >
                    <ListGroup horizontal="md" className="py-0" key={item}>
                      <ListGroup.Item
                        key={uuid()}
                        className="py-0 border-0"
                        style={{ backgroundColor: 'transparent', width: '50%' }}
                      >
                        Schema: {item}
                      </ListGroup.Item>

                      <ListGroup.Item
                        key={uuid()}
                        className="py-0 border-0"
                        style={{ backgroundColor: 'transparent', width: '50%' }}
                      >
                        Email: {email}
                      </ListGroup.Item>
                    </ListGroup>
                  </ListGroup.Item>
                );
              })}
            </ListGroup>
            <PaginationComponent
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setFilte={setFilte}
              elementePage={15}
              indexArray={indexArray}
              elementPaginttion={11}
            />
          </Col>

          <Col xs={4}>
            <Row>
              <Col xs={6}>
                <Form.Check
                  type="switch"
                  id="only"
                  key="Only"
                  label="Only Users"
                  checked={isUsers}
                  onChange={() => fiterbyUser()}
                />
              </Col>
              <Col xs={6}>
                <div className="position-relative">
                  <FontAwesomeIcon
                    className="position-absolute"
                    style={{
                      left: '12px',
                      top: '10px'
                    }}
                    color="var(--gray-light)"
                    icon="search"
                  />
                  <Form.Control
                    type="text"
                    name="search"
                    className="pl-5"
                    placeholder="Search Layer"
                    onKeyUp={handleSearch}
                  />
                </div>
              </Col>
            </Row>

            <Form.Control name="connectorId" as="select" htmlSize={15} custom>
              <option value="" key={uuid()}>{`Tables in Schema : ${currentSchema} `}</option>{' '}
              {map(bodyfiltered, item => (
                <option value={item[0]} key={uuid()}>
                  {item[1]}
                </option>
              ))}
            </Form.Control>
          </Col>
        </>
      )}
    </Row>
  );
};
ServerInfra.propTypes = {
  loading: PropTypes.bool.isRequired,
  gmsConnections: PropTypes.array
};

ServerInfra.defaultProps = {
  gmsConnections: []
};
export default withTracker(() => {
  const gmsConnectionsSub = Meteor.isClient && Meteor.subscribe('gmsConnections');
  return {
    loading: !gmsConnectionsSub.ready(),
    gmsConnections: TelemetryConnections.find().fetch()
  };
})(ServerInfra);
